import React, {Fragment, useEffect, useState} from 'react';
import {getUrlParameter} from "../../../../service/util.service";
import {checkEmpty} from "../../../../utils/janus.utils";
import {getUrl} from "../../../../service/files.service";
import styles from "../../../../pages/Home/CreatePost/CoverPreview/CoverPreview.module.scss";
import {CaretRightOutlined, CloseOutlined} from "@ant-design/icons";
import {LazyLoadImage} from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
// import LazyLoad from 'react-lazyload';

interface CoverPreviewProps {
    photo: any
    isLast: boolean
    overflow: boolean
    overflowSize: number
    title?: string
    left?: string | number
    top?: string | number
    style?: any
    onClick?: () => void
    onClickImg?: () => void
    onClickVideo?: () => void
    open?: boolean
}

export const CoverPreview: React.FunctionComponent<CoverPreviewProps> = (props) => {

    const [width, setWidth] = useState<number>();
    const [height, setHeight] = useState<number>();

    const [URL1024, setURL1024] = useState<string>();
    const [videoURL, setVideoURL] = useState<string>();
    const [openVideo, setOpenVideo] = useState<boolean>();

    // const objectPosition = useMemo(() => {
    //     // console.log("width height", width, height, props.photo)
    //     if (!width || !height) return "100% 50%"
    //     if (height > width) return "100% 50%"
    //     return "50% 100%";
    // }, [width, height])

    useEffect(() => {

        if (props.photo.type === "image") {
            checkGetUrlFile1024();
        } else if (props.photo.type === "video") {
            checkGetUrlFile100();
        }
    }, [props.photo])

    // useEffect(() => {
    //     console.log("openVideo", openVideo);
    // }, [openVideo])

    const checkGetUrlFile1024 = async () => {
        let url: any = props.photo.src;

        if (props.photo.src.indexOf("&size=") == -1 && props.photo.src.indexOf("blob=") != -1)
            url = props.photo.src;
        if (props.photo.type === "image") {
            let id = getUrlParameter("fileId", url);
            if (!checkEmpty(id)) {
                url = await getUrl(url, id, 1024, "post");
            }
        }
        setURL1024(url);
    };

    const checkGetUrlFile100 = async () => {
        let url: any = props.photo.src;
        if (props.photo.src?.indexOf("&size=") == -1 && props.photo.src?.indexOf("blob=") != -1) {
            url = props.photo.src + "&size=1024";
        }
        if (props.photo.type === "video") {
            let id = getUrlParameter("fileId", url);
            if (!checkEmpty(id)) {
                url = await getUrl(url, id, 1024, "post");
                let size = getUrlParameter("size", url);
                if (checkEmpty(size) && url?.indexOf("FileService") != -1) {
                    url = url + "&size=1024";
                }
            }
        }
        setURL1024(url);
    };
    //
    // const renderImage = useMemo(() => {
    //     return <Fragment>
    //         {
    //             props.photo.type === "image" && (
    //                 <img
    //                     alt={props.photo.title}
    //                     onLoad={(e) => {
    //                         setWidth(e.currentTarget.naturalWidth);
    //                         setHeight(e.currentTarget.naturalHeight)
    //                         // console.log("imageLoaded", e.currentTarget.width);
    //                     }}
    //                     style={{
    //                         objectFit: "cover",
    //                         left: props.left,
    //                         top: props.top,
    //                         objectPosition: "center",
    //                         // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
    //                         // margin: "2px",
    //                         display: "block",
    //                         position: "absolute",
    //                         cursor: "pointer",
    //                         ...props.photo.style
    //                     }}
    //                     src={URL1024}
    //                     width={props.photo.width}
    //                     height={props.photo.height}
    //                     onClick={props.onClickImg}
    //                 />)
    //         }
    //     </Fragment>
    // }, [props.photo, props.left, props.top, URL1024])

    return (
        <Fragment>
            {/*{renderImage}*/}
            {
                props.photo.type === "image" && (
                    // <LazyLoad height={200}>
                    <LazyLoadImage
                        alt={props.photo.title}
                        // onLoad={(e) => {
                        //     setWidth(e.currentTarget.naturalWidth);
                        //     setHeight(e.currentTarget.naturalHeight)
                        //     // console.log("imageLoaded", e.currentTarget.width);
                        // }}
                        style={{
                            objectFit: "cover",
                            left: props.left,
                            top: props.top,
                            objectPosition: "center",
                            // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
                            // margin: "2px",
                            display: "block",
                            position: "absolute",
                            cursor: "pointer",
                            ...props.photo.style
                        }}
                        src={URL1024}
                        width={props.photo.width}
                        height={props.photo.height}
                        onClick={props.onClickImg}
                    />
                    // </LazyLoad>
                        )
            }
            { props.isLast && props.overflow &&
                <div
                    style={{
                        objectFit: "cover",
                        left: props.left,
                        top: props.top,
                        objectPosition: "center",
                        // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
                        // margin: "2px",
                        // display: "block",
                        position: "absolute",
                        cursor: "pointer",
                        ...props.photo.style,
                        width: props.photo.width,
                        height: props.photo.height,
                        transition: "0.2s ease-in-out",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#e8e8e8",
                        fontSize: "3rem",
                    }}
                     onClick={props.onClickImg}
                >{`+${props.overflowSize}`}</div>
            }
            {props.photo.type === "video" && (
                <Fragment>
                    <LazyLoadImage
                        alt={props.photo.title}
                        onLoad={(e) => {
                            setWidth(e.currentTarget.naturalWidth);
                            setHeight(e.currentTarget.naturalHeight)
                            // console.log("imageLoaded", e.currentTarget.width);
                        }}
                        style={{
                            objectFit: "cover",
                            left: props.left,
                            top: props.top,
                            objectPosition: "center",
                            // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
                            // margin: "2px",
                            display: "block",
                            position: "absolute",
                            cursor: "pointer",
                            ...props.photo.style
                        }}
                        src={URL1024}
                        width={props.photo.width}
                        height={props.photo.height}
                        onClick={props.onClickVideo}
                    />
                    {openVideo && (
                        <video
                            muted
                            style={{
                                width: width ? width : "158px",
                                height: height ? height : "100px",
                                // margin: margin ? margin : "",
                                position: "relative",
                                // borderRadius: 10,
                            }}
                        >
                            <source src={props.photo.src} type="video/mp4"/>
                            Your browser does not support HTML5 video.
                        </video>
                    )}
                    {openVideo && (
                        <div
                            className={styles.closeCover}
                            // onClick={() => handleCloseCover(coverUrl)}
                        >
                            <CloseOutlined className={styles.innerCloseCover}/>
                        </div>
                    )}

                    <div
                        style={{
                            objectFit: "cover",
                            left: props.left,
                            top: props.top,
                            objectPosition: "center",
                            // transform: `translateZ(0px) scale3d(${sx}, ${sy}, 1)`,
                            // margin: "2px",
                            display: "flex",
                            position: "absolute",
                            cursor: "pointer",
                            width: props.photo.width,
                            height: props.photo.height ? props.photo.height : "100%",
                            // ...props.photo.style
                        }}
                        onClick={props.onClickVideo}
                    >

                        <div className={styles.playVidBtn}>
                            <div
                                style={{ position: "relative", width: "100%", height: "100%" }}
                            >
                                <CaretRightOutlined
                                    className={styles.playVideo}
                                    style={{ fontSize: 70, color: "#FFFFFF" }}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment>

            )}
        </Fragment>
    )
}